import { assertNever } from '@openphone/lib/assertNever'
import type { RelayFieldLogger } from 'relay-runtime'

import { getRootLogger } from '@odyssey/logging/logger'

// useFragment reports on every render; the error object is reused until the next response.
const loggedPayloadErrors = new WeakSet<object>()

function getErrorCode(error: object) {
  if (!('extensions' in error)) {
    return undefined
  }
  const { extensions } = error
  return typeof extensions === 'object' && extensions !== null && 'code' in extensions
    ? extensions.code
    : undefined
}

export default function relayFieldLogger(fieldError: Parameters<RelayFieldLogger>[0]) {
  const log = getRootLogger().getChild('RelayFieldLogger')

  switch (fieldError.kind) {
    case 'missing_required_field.log':
    case 'missing_required_field.throw':
    case 'missing_expected_data.log':
    case 'missing_expected_data.throw': {
      log.error('{kind} at {fieldPath} in {owner}', {
        kind: fieldError.kind,
        fieldPath: fieldError.fieldPath,
        owner: fieldError.owner,
      })
      break
    }
    case 'relay_field_payload.error': {
      const { error } = fieldError
      if (loggedPayloadErrors.has(error)) {
        break
      }
      loggedPayloadErrors.add(error)
      log.error('{error} at {fieldPath} in {owner}', {
        error: error.message,
        code: getErrorCode(error),
        fieldPath: fieldError.fieldPath,
        owner: fieldError.owner,
      })
      break
    }
    case 'relay_resolver.error': {
      const { error } = fieldError
      log.error('{error} at {fieldPath} in {owner}', {
        error: error.message,
        fieldPath: fieldError.fieldPath,
        owner: fieldError.owner,
      })
      break
    }
    default:
      assertNever(fieldError, 'Unhandled relay field error kind')
  }
}
